<template>
  <div>
    <Button
        v-if="nextButtonVisibility"
        class="btn"
        @click.prevent="handleNextButtonClick"
    >Next
    </Button>
  </div>
</template>

<script>
export default {
  props: ['offset', 'limit', 'maxItems'],
  name: "FootprintTableNextButton",
  methods: {
    handleNextButtonClick() {
      if (this.nextButtonVisibility)
        this.$emit('on-next-button-click', this.offset + this.limit)
    }
  },
  computed: {
    nextButtonVisibility() {
      return this.offset + this.limit < this.maxItems
    }
  }
}
</script>

<style scoped>

</style>